export default "__VITE_ASSET__734b61f8__"